import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {NomenclatureDocument, NomenclatureDocumentSearchParams, NomenclatureDocumentType} from '@accounting/_common/models/nomenclature-document.models';

export const CheckState = createAction(
    '[NomenclatureDocument] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: NomenclatureDocument[], documentType: NomenclatureDocumentType | 'CROSS' } }>()
);

export const CheckStateSuccess = createAction(
    '[NomenclatureDocument] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: NomenclatureDocument[], documentType: NomenclatureDocumentType | 'CROSS' } }>()
);

export const LoadList = createAction(
    '[NomenclatureDocument] Load List',
    props<{ payload: { loading: DahLoadingType, documentType: NomenclatureDocumentType | 'CROSS', clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[NomenclatureDocument] Load List Success',
    props<{ payload: { items: NomenclatureDocument[], pagination: DahPaginationModel, documentType: NomenclatureDocumentType | 'CROSS', clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[NomenclatureDocument] Load List Failure',
    props<{ payload: { error: HttpErrorResponse, documentType: NomenclatureDocumentType | 'CROSS' } }>()
);

export const SetPagination = createAction(
    '[NomenclatureDocument] Set Pagination',
    props<{ payload: { next: boolean, documentType: NomenclatureDocumentType | 'CROSS' } }>()
);

export const SetFilter = createAction(
    '[NomenclatureDocument] Set Filter',
    props<{ payload: { filter: NomenclatureDocumentSearchParams, documentType: NomenclatureDocumentType | 'CROSS' } }>()
);

export const SetLoading = createAction(
    '[NomenclatureDocument] Set Loading',
    props<{ payload: { loading: DahLoadingType, documentType: NomenclatureDocumentType | 'CROSS' } }>()
);

export const SetItemsLoading = createAction(
    '[NomenclatureDocument] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean, documentType: NomenclatureDocumentType | 'CROSS' } }>()
);

export const UpdateItemSuccess = createAction(
    '[NomenclatureDocument] Update Item Success',
    props<{ payload: { item: NomenclatureDocument, documentType: NomenclatureDocumentType | 'CROSS' } }>()
);

export const DeleteItem = createAction(
    '[NomenclatureDocument] Delete Item',
    props<{ payload: { item: NomenclatureDocument, documentType: NomenclatureDocumentType | 'CROSS' } }>()
);

export const DeleteItemSuccess = createAction(
    '[NomenclatureDocument] Delete Item Success',
    props<{ payload: { item: NomenclatureDocument, documentType: NomenclatureDocumentType | 'CROSS' } }>()
);

export const DeleteItemFailure = createAction(
    '[NomenclatureDocument] Delete Item Failure',
    props<{ payload: { item: NomenclatureDocument, documentType: NomenclatureDocumentType | 'CROSS' } }>()
);

export const SetInitialState = createAction(
    '[NomenclatureDocument] Set Initial State'
);
